module.exports = __webpack_public_path__ + "static/img/partner-4.ee3df9ea.png";